//code from UserAgentInfoProvider.java

function getTimeZone(){
  try{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }catch(e){
    let offset = new Date().getTimezoneOffset()/60;
    return (offset<0) ? ("GMT+"+(-offset) ):( "GMT-"+offset);
  }
}
const 
  reg = /^.*((iphone)|(ipod)|(android)|(blackberry)|(opera)|(mini)|(windows\\sce)|(windows\\sphone)|(palm)|(smartphone)|(iemobile)|(AEORK)|(Facebook)).*$/i,
  matcher = navigator.userAgent.match(reg),
  isMobile = !!matcher, //si rien ne match ben on est pas mobile
  isIPhone = isMobile && (matcher[2] || matcher[3]),
  isEchoShow = isMobile && matcher[13], 
  isFacebook = isMobile && matcher[14], //TODO this one was just guessed
  isAndroid = isMobile && (matcher[4]),
  isWindows = isMobile && (matcher[8] || matcher[9] || matcher[12]),
  hasApp = (isIPhone || (isAndroid && !isEchoShow && !isFacebook)),
  code = !isMobile?"PC":(isIPhone?"IOS":(isAndroid?"Android":(isWindows?"Windows":"Mobile"))),
  OS = {
    code:code,
    isMobile:isMobile,
    isIPhone:isIPhone,
    isAndroid:isAndroid,
    isWindows:isWindows,
    hasApp:hasApp,
    getTimeZone
  };

if(navigator.canShare){
  if(navigator.canShare({text:"text"})){
    OS.canShare = true;
  } 
}

export {code,isMobile,isIPhone,isAndroid,isWindows,hasApp,OS,getTimeZone};